export default {
	sec_10: {
		title: {
			one: "JP WORLD Pay's unique",
			two: 'account system',
		},
		desc: {
			one: "You don't just have an account at a bank. JP WORLD Pay",
			two: 'provides an account for even more convenience.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_13: {
		title: {
			one: 'Experience fast transfers with the',
			two: 'JP WORLD Pay ',
			three: 'account system now.',
		},
		features: {
			one: {
				title: {
					one: 'Faster with our unique',
					two: 'account system',
				},
				description: {
					one: 'When transferring funds from JP WORLD Pay to your JP WORLD Pay account, ',
					two: 'transfers now take place within 1-3 seconds. No more waiting.',
				},
			},
			two: {
				title: {
					one: 'Create a money',
					two: 'transfer system',
				},
				description: {
					one: 'When transferring money from JP WORLD Pay to JP WORLD Pay ',
					two: 'using your account, there are no fees and it saves time.',
				},
			},
		},
	},
};
